import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { RefreshProvider } from "@/context/RefreshContext";
import Shell from "@/components/Shell";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Transactions from "@/pages/Transactions";
import Machines from "@/pages/Machines";
import Groups from "@/pages/Groups";
import Merchants from "@/pages/Merchants";
import Performance from "@/pages/Performance";

function Protected({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-muted-foreground">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

function AppRoutes() {
  const { user } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" replace /> : <Login />} />
      <Route path="/" element={<Protected><Shell /></Protected>}>
        <Route index element={<Dashboard />} />
        <Route path="transactions" element={<Transactions />} />
        <Route path="machines" element={<Machines />} />
        <Route path="machines/:id" element={<Machines />} />
        <Route path="groups" element={<Protected roles={["admin"]}><Groups /></Protected>} />
        <Route path="merchants" element={<Protected roles={["admin"]}><Merchants /></Protected>} />
        <Route path="performance" element={<Protected roles={["merchant"]}><Performance /></Protected>} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <RefreshProvider>
          <BrowserRouter>
            <AppRoutes />
          </BrowserRouter>
        </RefreshProvider>
        <Toaster theme="dark" position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}
